package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_message_data_di_MessageModule : Module get() = module {
	single() { _ -> com.essntl.features.message.data.repository.MessageRepositoryImpl(messageDataSource=get(),waypoint=get(),twilio=get(),whatsapp=get()) } bind(com.essntl.features.message.domain.repository.MessageRepository::class)
	single() { _ -> com.essntl.features.message.data.supabase.conversation.ConversationSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.message.data.supabase.conversation.ConversationSupabaseDataSource::class)
	single() { _ -> com.essntl.features.message.data.supabase.message.MessageSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.message.data.supabase.message.MessageSupabaseDataSource::class)
}
public val com.essntl.features.message.data.di.MessageModule.module : org.koin.core.module.Module get() = com_essntl_features_message_data_di_MessageModule
